import React, { useState } from "react";
import "./ObjectDetectionViewer.css";

const ObjectDetectionViewer = ({ imageUrl, detectedItems = [] }) => {
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

  const hasDetections = Array.isArray(detectedItems) && detectedItems.length > 0;
  const canScale = imageSize.width > 0 && imageSize.height > 0;

  return (
    <div className="object-detection-container">
      <img
        src={imageUrl}
        alt="Complaint Waste"
        className="detection-base-image"
        onLoad={(event) => {
          setImageSize({
            width: event.currentTarget.naturalWidth,
            height: event.currentTarget.naturalHeight,
          });
        }}
      />
      {hasDetections && canScale &&
        detectedItems.map((item, index) => {
          const leftPercent = ((item.x - item.width / 2) / imageSize.width) * 100;
          const topPercent = ((item.y - item.height / 2) / imageSize.height) * 100;
          const widthPercent = (item.width / imageSize.width) * 100;
          const heightPercent = (item.height / imageSize.height) * 100;

          return (
            <div
              key={index}
              className="detection-bounding-box"
              style={{
                left: `${leftPercent}%`,
                top: `${topPercent}%`,
                width: `${widthPercent}%`,
                height: `${heightPercent}%`,
              }}
            >
              <div className="detection-box-label">
                {item.className} ({Math.round(item.confidence * 100)}%)
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default ObjectDetectionViewer;
